
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/refinancing",
      function () {
        return require("private-next-pages/investors/refinancing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors/refinancing"])
      });
    }
  